import { render, staticRenderFns } from "./GetMessagesInbox.vue?vue&type=template&id=26aa7dd2&"
import script from "./GetMessagesInbox.vue?vue&type=script&lang=js&"
export * from "./GetMessagesInbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports